import SupporterSignUpContextProvider from "./context/SupporterStatusContext";
import { CsoQuestionaire } from "./CsoQuestionaire";

const WrappedCsoUpdatePreference = ({ open, setOpen, backToInitialPage }) => {
  return (
    <SupporterSignUpContextProvider>
      <CsoQuestionaire
        open={open}
        setOpen={setOpen}
        backToInitialPage={backToInitialPage}
        update={true}
      />
    </SupporterSignUpContextProvider>
  );
};

export default WrappedCsoUpdatePreference;
